// Si hacen falta catorce años, calculado también en el navegador.
//
// POR QUE ESTA REGLA ESTA DOS VECES. La de verdad es la del servidor
// (`backend/app/domain/edad.py`): es la que decide si una cuenta se abre, y la única en la
// que se puede confiar. Ésta no decide nada — sirve para que el formulario sepa si tiene que
// pedir el correo del tutor ANTES de enviar, en vez de rebotar al alumno con un error.
//
// Y por eso hay un portero: `tools/check_edad.py` ejecuta las dos sobre una rejilla de
// fechas y se cae si difieren en una sola. Dos copias de una regla que nadie compara se
// separan siempre, y aquí separarse significa pedirle el correo de su padre a quien no lo
// necesita, o no pedírselo a quien sí.

export const EDAD_DE_DECIDIR = 14;
export const AÑOS_MAXIMOS = 100;

/**
 * `true`, `false` o `null` cuando lo que llega no es un año y un mes.
 *
 * `null` NO es «menor»: es «todavía no ha contestado». El formulario tiene que distinguirlas
 * o enseñará la pregunta del tutor a quien aún no ha tocado el desplegable.
 *
 * Durante el mes del cumpleaños se cuenta como menor: con el año y el mes no se sabe el día,
 * y el redondeo va hacia el lado que protege. Pedir un permiso que no hacía falta molesta;
 * no pedirlo cuando hacía falta es tratar los datos de un menor sin base legal.
 */
export function esMayorDe14(anio, mes, hoy = new Date()) {
  const a = Number(anio);
  const m = Number(mes);
  if (!Number.isInteger(a) || !Number.isInteger(m)) return null;
  if (m < 1 || m > 12) return null;
  const esteAnio = hoy.getUTCFullYear();
  if (a < esteAnio - AÑOS_MAXIMOS || a > esteAnio) return null;
  const esteMes = hoy.getUTCMonth() + 1;
  const cumpleAnio = a + EDAD_DE_DECIDIR;
  return esteAnio > cumpleAnio || (esteAnio === cumpleAnio && esteMes > m);
}

/** Los años que tiene sentido ofrecer, del más reciente al más antiguo. */
export function aniosOfrecidos(hoy = new Date()) {
  const fin = hoy.getUTCFullYear();
  const salida = [];
  for (let a = fin; a >= fin - 90; a -= 1) salida.push(a);
  return salida;
}

export const MESES = [
  "enero", "febrero", "marzo", "abril", "mayo", "junio",
  "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre",
];
